import { render, staticRenderFns } from "./DasherDeleteRequest.vue?vue&type=template&id=fe8bf888"
import script from "./DasherDeleteRequest.vue?vue&type=script&lang=js"
export * from "./DasherDeleteRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports